import { Table } from 'semantic-ui-react';
import React from 'react';

export default function StageAssigneeRow({ stageAssignee }) {
  return (
    <>
      <Table.Row>
        <Table.Cell width="6" className="name">
          {stageAssignee.name}
        </Table.Cell>
        <Table.Cell width="6" className="role">
          {stageAssignee.role}
        </Table.Cell>
      </Table.Row>
    </>
  );
}
